import $ from 'jquery';
//import '../components/_select-custom';
import '../vendor/livesearch/src/_jquery.live-search';

import 'sumoselect';

$(document).ready(function () {

    const container = $("[js-filter-list]");

    const action = container.data('filter-list-action');
    const itemPerPage = container.data('filter-list-per_page') || 12;

    const selects = $('.select-form');


    const initCustomSelect = function(){


        $('select').each(function() {

            $(this).SumoSelect({
                disableOnMobile: true,
                nativeOnMobile: true,
                captionFormat: '{0} sélectionnés',
                placeholder: 'Filtrer par cible'
            });
        });
    };

    container.liveSearch({
        path: "/wp/wp-admin/admin-ajax.php",
        action: action,
        perPage: itemPerPage,
        resultsContainer: "[js-filter-destination]",
        paginationContainer: ".pagination",
        filters: ".select-form",
        order: ".order-form",
        reset: "[js-reset-filter]",
        submit: ".ok-button",
        render: function (item) {
            if('string' === typeof item){
                return item;

            }
        }
    });
    container.on("livesearch.loaded", function (event, filters) {
        initCustomSelect();
    });

    container.on("livesearch.BeforeFilterChange",  function(event, filters, previousFilters){
        event.preventDefault();

        if(filters["keyword"] && !previousFilters["keyword"]){
            filters["category-0"] = "";
            $('select[name="category-0"]').prop('selectedIndex',0).trigger("change");
            $('select[name="category-0"]')[0].sumo.reload();

            filters["category-1"] = "";
            $('select[name="category-1"]').prop('selectedIndex',0).trigger("change");
            $('select[name="category-1"]')[0].sumo.reload();

        }else if (filters["category-0"] && !previousFilters["category-0"]) {
            filters["keyword"] = "";
            $('input[name="keyword"]').val("");
        }

        return filters;
    });

    container.on("livesearch.rendered", function (event, datas) {

        if (datas.items && datas.items.length) {
            $("[js-filter-empty-results]").hide();
            $('.article-card').each(function( index ) {
                let _this = $(this);
                setTimeout(function () {
                    _this.addClass('aos-animate');
                }, 100);
            });
        } else {
            setTimeout(function () {
                $("[js-filter-empty-results]").show();
            }, 500);

            $('[js-filter-placeholder]').fadeOut();
        }
    });

    $('.btn-submit').on('click', function () {
        $('#search-input').change();
    });

});